import React, { Component } from "react";
import { RiCloseCircleFill } from "react-icons/ri";
import { Redirect } from "react-router-dom";
import Swal from "sweetalert2";
import ImageProvider from "../../../base/features/blocks/ImageProvider";
import LoginModal from "../../../base/features/blocks/LoginModal";
import BackButton from "../../../base/features/micro/BackButton";
import SimpleLabel from "../../../base/features/micro/SimpleLabel";
import { addComment, addShopComment } from "./services";
import { getProductId, getShopUid } from "../../../settings/domainManager";
import { navigate_to_product } from "../../../navigator/user/product";

class AddComment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: "",
      redirect: false,
      private: false,
      images: [],
      product_id: getProductId(),
      shop_uid: getShopUid(),
    };
  }
  sendComment() {
    if (!localStorage.getItem(`${window.location.hostname}_token`)) {
      this.setState({ loginModal: true });
      return;
    }
    const formData = new FormData();
    formData.append("comment", this.state.comment);
    formData.append("private", this.state.private);
    if (this.state.images.length > 0) {
      formData.append("image", this.state.images[0].file);
    }
    if (this.state.product_id) {
      addComment(formData, this.state.product_id).then((items) => {
        items &&
          Swal.fire({
            icon: "success",
            text: "با موفقیت ثبت شد",
            timer: 2000,
            confirmButtonText: "تایید",
          }).then(() => this.setState({ redirect: true }));
      });
    } else {
      addShopComment(formData, this.state.shop_uid).then((items) => {
        items &&
          Swal.fire({
            icon: "success",
            text: "با موفقیت ثبت شد",
            timer: 2000,
            confirmButtonText: "تایید",
          }).then(() => window.history.back());
      });
    }
  }

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          push
          to={navigate_to_product(
            this.state.shop_uid,
            this.state.product_id,
            false
          )}
        />
      );
    }
    return (
      <div className="container-fluid">
        {this.state.loginModal && <LoginModal notReload={true} />}
        <header
          className="row mx-0 px-4 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0" }}
        >
          <div className="col-auto align-self-center px-0">
            <BackButton />
          </div>
          <div className="col text-start align-self-center px-0">
            <button
              onClick={() => this.sendComment()}
              className="btn fs-6 p-0 fw-bolder mb-0"
              disabled={!this.state.comment}
            >
              ارسال
            </button>
          </div>
        </header>
        <body style={{ marginTop: "80px" }}>
          <div className="row mx-0 px-0 mt-3">
            <div className="col-12 px-0">
              <p className="fw-bolder">نوشتن نظر</p>
            </div>
            <div className="col-12 px-0 position-relative">
              <textarea
                className="form-control rounded14 w-100 p-3"
                value={this.state.comment}
                onChange={(e) => this.setState({ comment: e.target.value })}
                rows="4"
                placeholder="با نظرتان بهترین انتخاب را برای دیگران فراهم کنید"
              />
              {this.state.comment && <SimpleLabel text="نظر" />}
            </div>
          </div>
          <div className="row mx-0 px-0 mt-3">
            <div className="col-12 px-0">
              <p className="fw-bolder">افزودن عکس</p>
            </div>
            <div className="col-4 px-0">
              <ImageProvider
                images={this.state.images}
                updateImages={(images) => this.setState({ images: images })}
              />
            </div>
            {this.state.images.length > 0 &&
              this.state.images.map((image, i) => (
                <div
                  className="col-4 p-1 position-relative text-center rounded14 "
                  style={{ height: "100px" }}
                >
                  <img
                    alt="camera"
                    className="w-100 h-100 img-cover"
                    src={image.data_url}
                  />
                  <RiCloseCircleFill
                    onClick={() => this.setState({ images: [] })}
                    className="position-absolute text-muted"
                    style={{ top: "7px", right: "7px" }}
                    size="25"
                  />
                </div>
              ))}
          </div>
          <div className="row mx-0 mt-3">
            <div className="col-12 px-0">
              <input
                class="form-check-input mt-0 align-middle color-second"
                type="checkbox"
                name="exampleRadios"
                value={this.state.private}
                onChange={(e) =>
                  this.setState({ private: !this.state.private })
                }
              />
              <label
                class="form-check-label me-3 fw-bolder"
                for="defaultCheck1"
              >
                نظر شخصی
              </label>
            </div>
          </div>
        </body>
      </div>
    );
  }
}

export default AddComment;
